<template>
  <component :is="widget" v-if="widget" />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, shallowRef, watch } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { duckStatus } from './duckApi';

// The only thing the rest of the app knows about the duck (one line in App.vue). It asks the server whether the duck
// is switched on and only then loads the widget's code, so with the duck off nothing of it is downloaded.
export default defineComponent({
  name: 'DuckMount',
  setup() {
    const auth = useAuthStore();
    const widget = shallowRef<unknown>(null);
    watch(() => [auth.token, auth.needsBrokerage, auth.role], async () => {
      widget.value = null;
      if (!auth.token || auth.needsBrokerage || auth.isViewer) return;
      try {
        const status = await duckStatus();
        if (status.enabled) {
          widget.value = defineAsyncComponent(() => import('./DuckWidget.vue'));
        }
      } catch (e) {
        // no duck is better than a broken page
      }
    }, { immediate: true });
    return { widget };
  },
});
</script>
